import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
    selector: 'app-employee1-list',
    templateUrl: './../../../templates/forms/modals/employee2-list.component.html',
})
export class Employee2ListComponent implements OnInit {


    @Input()
    modalShow: boolean = true;


    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "Employee2Listid"

    dataObj: any;
    employeeList = [];
    searchFields: any[] = ['EMP_NAME_ID', 'JOBTITLE', 'BU_NAME', 'COMPANY_NAME'];
    public searchString;
    constructor(
        public langService: LangService,
        public gridService: GridService,
        private dataLoadService: DataLoadService) {
        this.colObj = [
            { headerName: 'EMP_NAME_ID', field: 'EMP_NAME_ID', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.jobTitle, field: 'JOBTITLE', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.buName, field: 'BU_NAME', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.companyName, field: 'COMPANY_NAME', sortable: true, resizable: true, hide: false }
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);
    
        this.dataLoadService.load('FG_HR1002_EMP_INTROD_LIST').subscribe(result => {
            this.employeeList =  result.body;
        })

    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }
}
